import { updateDateSeperator } from "@/apiUtils/commonUtils";
import IconSaveDocument from "@/assets/icons/saved-doc.svg?react";
import { PrescriptionData, TranslationData } from "@/common/lib/types";
import PrescriptionCard from "@/components/myAccount/prescriptions/PrescriptionCard";

interface IProps {
  hideDelete?: boolean;
  translations: TranslationData;
  prescription: PrescriptionData;
  handleDelete?: (id: string) => Promise<void>;
  handleEdit?: (prescription: PrescriptionData) => Promise<void>;
  handleSelect?: (prescription: PrescriptionData) => Promise<void>;
}

const UseSavedPrescription = ({ translations, prescription }: IProps) => {
  return (
    <div className="w-full border">
      <div className="flex w-full cursor-pointer items-center">
        <div className="flex h-16 w-16 items-center justify-center">
          <IconSaveDocument />
        </div>
        <div className="ml-4 w-full bg-tertiary-3 p-4">
          <h3 className="text-sm font-semibold">
            {
              translations?.lensConfigurator
                ?.lens_config_review_section_use_saved_prescription_title
            }
          </h3>
          <p className="text-[0.75rem] text-tertiary-6">
            {
              translations?.lensConfigurator
                ?.lens_config_review_section_use_saved_prescription_subtitle
            }
          </p>
        </div>
      </div>
      {prescription && (
        <div className="w-full border-t p-5">
          <PrescriptionCard
            // variant="select"
            // onAction={() => {}}
            // translations={translations}
            translations={translations}
            prescription={{ ...prescription, date: updateDateSeperator(prescription.date, ".") }}
          />
        </div>
      )}
    </div>
  );
};

export default UseSavedPrescription;
